/* eslint-disable */
export default {
  _Obstacle_Bottom: 'Obstacle_Bottom',
  _Reindeer: 'Reindeer',
  _Present_1: 'Present_1',
  _Obstacle_Top: 'Obstacle_Top',
  _Present_2: 'Present_2',
  _TitleSantaBody_Wave: 'TitleSantaBody_Wave',
  _TitleCane: 'TitleCane',
  _0: '0',
  _2: '2',
  _4: '4',
  _TapClick: 'TapClick',
  _Sparkle_3: 'Sparkle_3',
  _CaneParticle_1: 'CaneParticle_1',
  _CaneParticle_2: 'CaneParticle_2',
  _Nose_2: 'Nose_2',
  _SnowFlake: 'SnowFlake',
  _CaneParticle_3: 'CaneParticle_3',
  _ShowClick: 'ShowClick',
  _TitleSantaBody_Idle: 'TitleSantaBody_Idle',
  _Tree_1: 'Tree_1',
  _Star: 'Star',
  _ShowTap: 'ShowTap',
  _JR: 'JR',
  _BtnGo: 'BtnGo',
  _CanePiece_Red: 'CanePiece_Red',
  _CanePiece_White: 'CanePiece_White',
  _Sparkle_2: 'Sparkle_2',
  _Sparkle_4: 'Sparkle_4',
  _CaneParticle_4: 'CaneParticle_4',
  _Nose_1: 'Nose_1',
  _Title_2: 'Title_2',
  _Title_1: 'Title_1',
  _TitlePresent_1: 'TitlePresent_1',
  _InstructClick: 'InstructClick',
  _GetReady: 'GetReady',
  _Present_3: 'Present_3',
  _GameOver: 'GameOver',
  _TitlePresent_3: 'TitlePresent_3',
  _BestScore: 'BestScore',
  _Sparkle_1: 'Sparkle_1',
  _6: '6',
  _Tree_2: 'Tree_2',
  _Santa_Drive: 'Santa_Drive',
  _Santa_Wave: 'Santa_Wave',
  _Tree_3: 'Tree_3',
  _Cloud_1: 'Cloud_1',
  _1: '1',
  _ClickClick: 'ClickClick',
  _Arrow: 'Arrow',
  _Score: 'Score',
  _InstructTap: 'InstructTap',
  _Cloud_2: 'Cloud_2',
  _TitlePresent_2: 'TitlePresent_2',
  _Cloud_3: 'Cloud_3',
  _8: '8',
  _TitleSantaArmWave: 'TitleSantaArmWave',
  _3: '3',
  _5: '5',
  _7: '7',
  _9: '9',
}